// extracted by mini-css-extract-plugin
export default {"saving":"Notifications_saving__v5ui0"};